module.exports = __webpack_public_path__ + "media/דוב.d74d73c1.mp3";